import { currentDevice } from '../../core/utils/currentDevice'
import clickOutside from '../../utils/click_outside'
import { readCookie, setCookie } from '../../utils/cookie_manager'

$(document).on('click', '.language-selector .language-selector__current', function (e) {
  e.preventDefault()
  const $target = $(this)

  calculateChildrenPosition($target)
})

$(document).on('click', '.language-selector li a', function () {
  var locale = $(this).data('locale')
  sessionStorage.removeItem('fastbooking_data')
  setCookie('update_utag_data', true)
  if (locale !== undefined) {
    setCookie('locale', locale)
    IB.cookieManager.deleteCookies(['language'])
    setCookie('language', locale, -1)
  }
})

$(document).on('click', '.language-elements li.language', function () {
  IB.cookieManager.deleteCookies(['language'])
  setCookie('language', '', -1)
})

function calculateChildrenPosition($target) {
  const languageSelectorFooter = $target.closest('.js-footer-selector')
  const $submenuWrapper = $target.closest('.language-selector').find('.drop-down-links')

  const dropdownHeight = $submenuWrapper.outerHeight()
  const dropdownHalfHeight = dropdownHeight / 2

  // Size icon after (12px) - margin-left icon after (8px) - margin right icon before (8px)
  const ADDITIONAL_MEASURES_ICONS = 12 + 8 + 8

  const target = $target[0]
  const boundingRect = target.getBoundingClientRect()
  const MENU_POSITION_LEFT = Math.round(boundingRect.right) - ADDITIONAL_MEASURES_ICONS

  const menuItemPos = $target.position()
  const isMobile = currentDevice.isMobile

  const getTopPosition = () => {
    if (isMobile && languageSelectorFooter) {
      return menuItemPos.top + 12 - dropdownHalfHeight
    }

    const padding = isMobile ? 8 : 10
    return menuItemPos.top + $target.outerHeight() + padding
  }

  const getLeftPosition = () => {
    return isMobile && languageSelectorFooter ? MENU_POSITION_LEFT : menuItemPos.left
  }

  const topPosition = getTopPosition()
  const leftPosition = getLeftPosition()

  if (!$submenuWrapper.is(':visible')) {
    let styles = {
      top: topPosition,
      left: leftPosition,
    }

    if ($target.closest('.main-nav__language-selector').length) {
      styles = {
        ...styles,
        transform: `translateY(calc(-100% - ${$target.closest('.language-selector').outerHeight()}px - 16px))`,
      }

      $submenuWrapper.addClass('to-top')
    }

    $submenuWrapper.css(styles)
    $submenuWrapper.slideToggle('fast')
  } else {
    $submenuWrapper.hide()
  }
}

$(function () {
  const cookieLocale = readCookie('locale')
  const languajeSelectorLinks = document.querySelector('ul.js-language-selector-links li.active a')
  const selectorLocale = languajeSelectorLinks !== null ? languajeSelectorLinks.getAttribute('data-locale') : null
  if (selectorLocale !== null && cookieLocale != selectorLocale) {
    sessionStorage.removeItem('fastbooking_data')
    setCookie('locale', selectorLocale)
    ajax_utag_callback()
  }

  const languageSelectors = document.querySelectorAll(
    '.language-selector .language-selector__current, .language-selector .drop-down-links'
  )

  clickOutside(languageSelectors, (event, langSelectors) => {
    const languageOptionsContainers = document.querySelectorAll('.language-selector .drop-down-links')
    languageOptionsContainers.forEach(langSelector => {
      langSelector.style.display = 'none'
    })
  })
})
